/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import AmountField from 'app/main/components/AmountField';
import PercentageField from 'app/main/components/PercentageField';
import { roundNumber, calcAmountFrom, calcPercentageFrom } from 'app/main/utils/numberUtils';

export default function PercentageAndAmountField(props) {
  const { id, className, value, total, onChange: handleChange, ...other } = props;

  // Rendering flag prevents the percentage to change the value if is first time or the amount is changing.
  const [renderingFlag, setRenderingFlag] = useState(true);

  const amount = roundNumber(parseFloat(value));

  const percentage = roundNumber(calcPercentageFrom(amount, total));

  useEffect(() => {
    setRenderingFlag(false);
  }, [setRenderingFlag, value]);

  const handleAmountChange = event => {
    setRenderingFlag(true);
    if (event.target.value === amount) {
      return;
    }
    handleChange(event);
  };
  const handlePercentageChange = event => {
    if (renderingFlag) {
      return;
    }
    const newPercentage = roundNumber(parseFloat(event.target.value));
    const newAmount = roundNumber(calcAmountFrom(newPercentage, total));
    if (newAmount === amount) {
      return;
    }
    handleChange({
      target: {
        name: id,
        value: newAmount
      }
    });
  };

  return (
    <div className={className} id={`${id}-amount-and-percentage`}>
      <AmountField className="pr-12 w-2/4" id={id} value={amount} onChange={handleAmountChange} {...other} />
      <PercentageField
        className="pl-6 w-2/4"
        id={`${id}-percentage`}
        value={percentage}
        onChange={handlePercentageChange}
      />
    </div>
  );
}
